module.exports = __webpack_public_path__ + "img/P150T_weapon_41.cecf29f5.png";